module.exports = __webpack_public_path__ + "img/pdf_hypergraph_framework.dbc37d67.jpg";